(() => {
  'use strict';
  const normalize = value => {
    let words = ` ${String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/(\d+)ml\b/g, '$1 ml').replace(/[^\p{L}\p{N}]+/gu, ' ').trim()} `;
    const aliases = {
      agarwood: 'oud', oudh: 'oud', 'عود': 'oud', pdm: 'parfums de marly', jpg: 'jean paul gaultier', lv: 'louis vuitton', ysl: 'yves saint laurent', mfk: 'maison francis kurkdjian',
      'for her': 'women', feminine: 'women', female: 'women', woman: 'women', 'for him': 'men', masculine: 'men', male: 'men', man: 'men',
      her: 'women', him: 'men', 'eau de parfum': 'perfume', edp: 'perfume', perfumes: 'perfume', parfum: 'perfume',
    };
    for (const [alias, canonical] of Object.entries(aliases)) words = words.replaceAll(` ${alias} `, ` ${canonical} `);
    return words.trim();
  };
  const matches = (terms, query) => {
    const indexed = ` ${normalize(terms)} `;
    const tokens = normalize(query).split(' ').filter(Boolean);
    return tokens.every((token, index) => indexed.includes(` ${token} `)
      || (index === tokens.length - 1 && token.length >= 3 && indexed.includes(` ${token}`)));
  };
  const search = (products, query) => products.filter(product => matches(product.terms, query)).map(product => {
    const title = normalize(product.title), q = normalize(query);
    const score = title === q ? 120 : title.startsWith(q) ? 80 : title.includes(q) ? 55 : normalize(product.context).includes(q) ? 35 : 0;
    return { product, score };
  }).sort((a, b) => b.score - a.score || a.product.title.localeCompare(b.product.title)).map(entry => entry.product);
  window.SiwaSearch = { normalize, matches, search };
})();
